import axios from 'axios';
import '../helpers/api_helper';
import { api } from '../config';

const BASE = api.API_URL;

export const getFinanzasV2DashboardMensual = (empresaId, year, month) =>
    axios.get(`${BASE}/finanzas/v2/dashboard-mensual`, {
        params: { empresa_id: empresaId, year, month },
    });

export const postSyncCuentas = (empresaId, year) =>
    axios.post(`${BASE}/finanzas/v2/sync/cuentas`, null, {
        params: { empresa_id: empresaId, year },
    });

export const postSyncMovimientosMes = (empresaId, year, month) =>
    axios.post(`${BASE}/finanzas/v2/sync/movimientos/mes`, null, {
        params: { empresa_id: empresaId, year, month },
    });

export const postSyncMovimientosEjercicio = (empresaId, year) =>
    axios.post(`${BASE}/finanzas/v2/sync/movimientos/ejercicio`, null, {
        params: { empresa_id: empresaId, year },
    });

export const getFinanzasV2Cierres = (empresaId, year) =>
    axios.get(`${BASE}/finanzas/v2/cierres`, {
        params: { empresa_id: empresaId, year },
    });

export const getFinanzasV2DashboardAnual = (empresaId, year) =>
    axios.get(`${BASE}/finanzas/v2/dashboard-anual`, {
        params: { empresa_id: empresaId, year },
    });
